// extracted by mini-css-extract-plugin
module.exports = {"Thumb":"ChapterPlayer_Thumb__2LHlK","ThumbZoom":"ChapterPlayer_ThumbZoom__P-tS4"};